/**
 * US equity sessions in America/New_York (Mon–Fri):
 * - premarket:  04:00–09:30
 * - regular:    09:30–16:00
 * - afterhours: 16:00–20:00
 */
const NY_PREMARKET_OPEN_MINUTES = 4 * 60; // 04:00
const NY_MARKET_OPEN_MINUTES = 9 * 60 + 30; // 09:30
const NY_MARKET_CLOSE_MINUTES = 16 * 60; // 16:00 (exclusive for regular)
const NY_AFTERHOURS_CLOSE_MINUTES = 20 * 60; // 20:00 (exclusive)

const toNyDate = (date = new Date()) =>
  new Date(date.toLocaleString('en-US', { timeZone: 'America/New_York' }));

/**
 * Current NY trading session.
 * @param {Date} [date]
 * @returns {'premarket'|'regular'|'afterhours'|'closed'}
 */
export const getNyMarketSession = (date = new Date()) => {
  const ny = toNyDate(date);
  const day = ny.getDay();
  if (day === 0 || day === 6) return 'closed';
  const minutes = ny.getHours() * 60 + ny.getMinutes();
  if (minutes >= NY_PREMARKET_OPEN_MINUTES && minutes < NY_MARKET_OPEN_MINUTES) return 'premarket';
  if (minutes >= NY_MARKET_OPEN_MINUTES && minutes < NY_MARKET_CLOSE_MINUTES) return 'regular';
  if (minutes >= NY_MARKET_CLOSE_MINUTES && minutes < NY_AFTERHOURS_CLOSE_MINUTES) return 'afterhours';
  return 'closed';
};

/**
 * Whether NY regular market session is open (weekdays 09:30–before 16:00 ET).
 * @param {Date} [date]
 * @returns {boolean}
 */
export const isNyMarketOpen = (date = new Date()) => getNyMarketSession(date) === 'regular';

/**
 * Whether we're in any live-quote window (premarket, regular or afterhours: 04:00–20:00 ET weekdays).
 * @param {Date} [date]
 * @returns {boolean}
 */
export const isNyLiveWindow = (date = new Date()) => getNyMarketSession(date) !== 'closed';
